import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tier-selector" }
const _hoisted_2 = ["disabled", "title", "onClick"]
const _hoisted_3 = { class: "tier-amount" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiers, (tier) => {
      return (_openBlock(), _createElementBlock("button", {
        key: tier,
        class: _normalizeClass(["tier-chip", { selected: tier === _ctx.selectedTier, disabled: _ctx.isDisabled(tier) }]),
        disabled: _ctx.isDisabled(tier),
        title: _ctx.disabledReason(tier),
        onClick: ($event: any) => (_ctx.$emit('select', tier))
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formatTier(tier)), 1),
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "tier-unit" }, "sats", -1))
      ], 10, _hoisted_2))
    }), 128))
  ]))
}